import { Component, OnInit, Inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { finalize, takeUntil } from 'rxjs/operators'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import dayjs from 'dayjs'

import { DevicesService } from '@shared/modules/devices/devices.service'
import { UtilityService } from '@core/services/utility.service'
import { DestroyService } from '@core/services/destroy.service'

import { DeviceInstallation } from '@shared/models/device.model'

@Component({
  selector: 'lin-install-date-correction-dialog',
  templateUrl: './install-date-correction-dialog.component.html',
  styleUrls: ['./install-date-correction-dialog.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class InstallDateCorrectionDialogComponent implements OnInit {
  form: FormGroup
  currentInstallDate: string

  isSubmitting = false

  get currentInstallDateFormatted(): string {
    return dayjs(this.currentInstallDate).tz().format('YYYY/MM/DD HH:mm')
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly devicesService: DevicesService,
    private readonly utilityService: UtilityService,
    private readonly destroyService: DestroyService,
    private readonly dialogRef: MatDialogRef<InstallDateCorrectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: DeviceInstallation,
  ) {
    this.currentInstallDate = this.data.installDate
  }

  ngOnInit(): void {
    this.initForm()
    this.setFormValues()
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      installDate: [{ value: '', disabled: true }],
      correctedDate: ['', Validators.required],
    })
  }

  private setFormValues(): void {
    this.form.patchValue({
      installDate: this.utilityService.dayjsDateTimeFormatting(this.currentInstallDate),
      correctedDate: dayjs(this.currentInstallDate),
    })

    this.form.markAsDirty()
  }

  correctInstallationDate(): void {
    const rawInstallDate = <string>this.form.get('correctedDate').value
    this.isSubmitting = true

    this.devicesService
      .correctInstallationDate(this.data.deviceId, this.data.id, {
        installDate: dayjs(rawInstallDate).tz().format(),
      })
      .pipe(
        finalize(() => (this.isSubmitting = false)),
        takeUntil(this.destroyService),
      )
      .subscribe(() => this.dialogRef.close(true))
  }
}
